"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Input } from "@/components/ui/input";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Loader, MapPin, Calendar, Users, User, Mail, Phone, ArrowRight, CircleCheck, MessageCircle } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
function BookingFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="7410" className="flex flex-col items-center justify-center p-8 text-center space-y-4 animate-in fade-in zoom-in duration-500">
        <div className="size-16 rounded-full bg-primary/20 flex items-center justify-center text-primary mb-2">
          <CircleCheck className="size-8" />
        </div>
        <h3 className="text-2xl font-serif font-bold text-white">Randevunuz Alındı!</h3>
        <p className="text-muted-foreground">{successMessage}</p>
        <Button variant="outline" className="mt-4 border-primary/40 text-white hover:bg-primary/10 hover:text-white rounded-sm" onClick={() => window.location.reload()}>
          Yeni Randevu Oluştur
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {}
        <FormField control={control} name="full_name" rules={{
        required: "Ad Soyad gereklidir"
      }} render={({
        field
      }) => <FormItem className="col-span-1 md:col-span-2">
              <FormLabel className="text-gray-300 font-sans text-sm tracking-wide">Ad Soyad</FormLabel>
              <FormControl>
                <div className="relative">
                  <User className="absolute left-3 top-2.5 size-4 text-primary/60" />
                  <Input placeholder="Adınız Soyadınız" className="pl-9 bg-background/30 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-primary rounded-sm" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="email_address" rules={{
        required: "E-posta gereklidir",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Geçersiz e-posta adresi"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-gray-300 font-sans text-sm tracking-wide">E-posta Adresi</FormLabel>
              <FormControl>
                <div className="relative">
                  <Mail className="absolute left-3 top-2.5 size-4 text-primary/60" />
                  <Input type="email" placeholder="ornek@mail.com" className="pl-9 bg-background/30 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-primary rounded-sm" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="phone_number" rules={{
        required: "Telefon numarası gereklidir"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-gray-300 font-sans text-sm tracking-wide">Telefon Numarası</FormLabel>
              <FormControl>
                <div className="relative">
                  <Phone className="absolute left-3 top-2.5 size-4 text-primary/60" />
                  <Input type="tel" placeholder="+90 5xx xxx xx xx" className="pl-9 bg-background/30 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-primary rounded-sm" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="pickup_location" rules={{
        required: "Tedavi türü gereklidir"
      }} render={({
        field
      }) => <FormItem className="col-span-1 md:col-span-2">
              <FormLabel className="text-gray-300 font-sans text-sm tracking-wide">Tercih Edilen Tedavi</FormLabel>
              <FormControl>
                <div className="relative">
                  <MapPin className="absolute left-3 top-2.5 size-4 text-primary/60" />
                  <Input placeholder="Örn: Gülüş Tasarımı, İmplant" className="pl-9 bg-background/30 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-primary rounded-sm" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="dropoff_location" rules={{
        required: "Ek notlar gereklidir"
      }} render={({
        field
      }) => <FormItem className="col-span-1 md:col-span-2">
              <FormLabel className="text-gray-300 font-sans text-sm tracking-wide">Ek Notlar</FormLabel>
              <FormControl>
                <div className="relative">
                  <MapPin className="absolute left-3 top-2.5 size-4 text-primary/60" />
                  <Input placeholder="Varsa belirtmek istediğiniz detaylar" className="pl-9 bg-background/30 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-primary rounded-sm" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="pickup_date" rules={{
        required: "Randevu tarihi gereklidir"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-gray-300 font-sans text-sm tracking-wide">Randevu Tarihi</FormLabel>
              <FormControl>
                <div className="relative">
                  <SafeHydrate><Calendar className="absolute left-3 top-2.5 size-4 text-primary/60" /></SafeHydrate>
                  <Input type="date" className="pl-9 bg-background/30 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-primary [color-scheme:dark] rounded-sm" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        {}
        <FormField control={control} name="passenger_count" rules={{
        required: "Kişi sayısı gereklidir",
        min: {
          value: 1,
          message: "En az 1 kişi"
        },
        max: {
          value: 10,
          message: "En fazla 10 kişi"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-gray-300 font-sans text-sm tracking-wide">Hasta Sayısı</FormLabel>
              <FormControl>
                <div className="relative">
                  <Users className="absolute left-3 top-2.5 size-4 text-primary/60" />
                  <Input type="number" min={1} max={10} placeholder="1" className="pl-9 bg-background/30 border-white/10 text-white placeholder:text-gray-500 focus-visible:ring-primary rounded-sm" {...field} />
                </div>
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {submitError && <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-sm text-red-400 text-sm font-sans">
          {submitError}
        </div>}

      <Button type="submit" size="lg" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-serif font-bold text-lg mt-6 rounded-sm tracking-wider transition-all duration-300" disabled={isSubmitting}>
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            İşleniyor...
          </> : <>
            Hemen Randevu Al
            <ArrowRight className="ml-2 size-5" />
          </>}
      </Button>

      <Link to="tel:05535523234" className="block w-full">
        <Button type="button" size="lg" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-serif font-bold text-lg mt-3 rounded-sm tracking-wider transition-all duration-300">
          Telefon ile Randevu Al
          <Phone className="ml-2 size-5" />
        </Button>
      </Link>
      
      <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab className="block w-full">
        <Button type="button" size="lg" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 font-serif font-bold text-lg mt-3 rounded-sm tracking-wider transition-all duration-300">
          Whatsapp ile Randevu Al
          <MessageCircle className="ml-2 size-5" />
        </Button>
      </Link>
      
      <p className="text-xs text-center text-muted-foreground mt-4 font-sans tracking-wide">
        Randevu oluşturarak hizmet şartlarımızı kabul etmiş olursunuz. Size en kısa sürede dönüş yapılacaktır.
      </p>
    </Form>;
}
export default function QuickShuttleBooking() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section id="book-an-appointment" className="dark bg-background text-foreground relative w-full min-h-[800px] flex items-center py-20 lg:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://dtaysegul.10web.cloud/wp-content/uploads/2026/04/IMG_5154-scaled-e1775304895527.jpg" alt="Lüks Diş Kliniği Atmosferi" className="w-full h-full object-cover object-center opacity-60" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-transparent" />
        <div className="absolute inset-0 bg-black/30 lg:hidden" /> {}
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          {}
          <div ref={sectionRef} className={cn("lg:col-span-5 transition-all duration-1000 transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <div className="bg-card/30 backdrop-blur-2xl border border-white/5 rounded-sm p-6 md:p-10 shadow-2xl">
              <div className="mb-8">
                <h2 className="text-4xl font-serif font-medium text-white mb-3 tracking-tight">Online Randevu</h2>
                <p className="text-muted-foreground font-sans leading-relaxed">
                  Gülüşünüzü uzman ellere emanet edin. Lüks ve konforlu bir diş sağlığı deneyimi için hemen randevunuzu planlayın.
                </p>
              </div>

              <FormProvider formKey="appointment_form_blog" formId="appointment_form_blog" sectionName="quick-shuttle-booking" defaultValues={{
              full_name: "",
              email_address: "",
              phone_number: "",
              pickup_location: "",
              dropoff_location: "",
              pickup_date: "",
              passenger_count: ""
            }} validationRules={{
              full_name: {
                required: true
              },
              email_address: {
                required: true,
                pattern: "email"
              },
              phone_number: {
                required: true
              },
              pickup_location: {
                required: true
              },
              dropoff_location: {
                required: true
              },
              pickup_date: {
                required: true
              },
              passenger_count: {
                required: true,
                min: 1,
                max: 10
              }
            }} submitText="Hemen Randevu Al" successMessage="Teşekkürler! Randevu talebiniz başarıyla alındı. Sizinle en kısa sürede iletişime geçeceğiz.">
                <BookingFormContent />
              </FormProvider>
            </div>
          </div>

          {}
          <div className="hidden lg:flex lg:col-span-7 flex-col justify-center items-end text-right space-y-10">
            <div className={cn("max-w-2xl transition-all duration-1000 delay-300 transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
              <h2 className="text-6xl md:text-8xl font-serif font-light text-white leading-[1.1] tracking-tighter drop-shadow-2xl">
                Işıltılı Bir Gülüş.<br />
                <span className="text-primary italic">Uzman Ellerde.</span>
              </h2>
              <p className="text-xl text-gray-300 mt-8 drop-shadow-md max-w-lg ml-auto font-sans leading-relaxed font-light">
                Diş Hekimi Ayşegül İnneci Uzun ile estetik ve sağlığın mükemmel uyumunu keşfedin. 
                Modern teknolojimiz ve butik hizmet anlayışımızla Kayseri'de fark yaratıyoruz.
              </p>
              
              <div className="flex flex-wrap justify-end gap-5 mt-12">
                {["Kişiye Özel Tedavi", "Modern Teknoloji", "Lüks Klinik Deneyimi", "Uzman Kadro"].map((benefit, i) => <div key={i} data-index={i} className="bg-white/5 backdrop-blur-md border border-white/10 px-6 py-3 rounded-sm text-sm font-sans font-light tracking-widest text-white flex items-center gap-3 transition-colors hover:border-primary/50">
                    <CircleCheck className="size-4 text-primary" />
                    {benefit.toUpperCase()}
                  </div>)}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}